<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['cancel-reasons-head-title']"
    :description="propsdata[0]['translation']['cancel-reasons-head-description']"
/>

    <div>
      <h1 style="text-align: center;" class="mt-7">{{propsdata[0]['translation']['cancel-reasons-title']}}</h1>
      <br>
      <div class="container nav-tabs border-0" style="overflow: scroll;display: flex;">
        <a href="/dashboard/account" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['cancel-reasons-tab-account-settings']}}</a>
        <router-link to="/dashboard/cancel-reasons" exact-active-class="activetabs" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['cancel-reasons-tab-cancel-subscription']}}</router-link>
      </div>
    </div>

    <div class="container mb-3">
      <div class="card border-light shadow-soft rounded-top-0 rounded-bottom">
        <div class="card-body p-4">
          <div>
            <div v-if="propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes'" class="col-12 p-0">
              <div v-if="!are_you_sure && !canceled" class="form-group">
                <h5 class="mb-2">{{propsdata[0]['translation']['cancel-reasons-question']}}</h5>
                <p>{{propsdata[0]['translation']['cancel-reasons-instructions']}}</p>
                <p v-if="select_reason" style="color:#ff0000">{{propsdata[0]['translation']['cancel-reasons-required']}}</p>
                <div class="form-check form-check-radio">
                  <label class="form-check-label">
                      <input class="form-check-input" type="radio" id="exampleRadios1" value="1" v-model="reason">
                      <span class="form-check-sign"></span>
                      {{propsdata[0]['translation']['cancel-reasons-reason-1']}}
                  </label>
                </div>
                <div class="form-check form-check-radio">
                  <label class="form-check-label">
                      <input class="form-check-input" type="radio" id="exampleRadios2" value="2" v-model="reason">
                      <span class="form-check-sign"></span>
                      {{propsdata[0]['translation']['cancel-reasons-reason-2']}}
                  </label>
                </div>
                <div class="form-check form-check-radio">
                  <label class="form-check-label">
                      <input class="form-check-input" type="radio" id="exampleRadios3" value="3" v-model="reason">
                      <span class="form-check-sign"></span>
                      {{propsdata[0]['translation']['cancel-reasons-reason-3']}}
                  </label>
                </div>
                <div class="form-check form-check-radio">
                  <label class="form-check-label">
                      <input class="form-check-input" type="radio" id="exampleRadios4" value="4" v-model="reason">
                      <span class="form-check-sign"></span>
                      {{propsdata[0]['translation']['cancel-reasons-reason-4']}}
                  </label>
                  <p v-if="fill_reason" style="color:#ff0000" class="mt-2">{{propsdata[0]['translation']['cancel-reasons-details']}}</p>
                  <input v-if="reason === '4'" v-model="other_reason" type="text" class="form-control mt-2" :placeholder="propsdata[0]['translation']['cancel-reasons-details-placeholder']"></input>
                </div>
                <div class="d-flex justify-content-between" style="gap: 5px;">
                  <a href="/dashboard/billing" class="btn btn-secondary mt-4 animate-up-2"><i class="fas fa-chevron-left"></i> {{propsdata[0]['translation']['cancel-reasons-return-to-billing']}}</a>
                  <button v-if="!saving" @click="save_reason" class="btn btn-danger mt-4 animate-up-2" style="float:right!important;">{{propsdata[0]['translation']['cancel-reasons-details-continue-button']}}</button>
                  <button v-if="saving" class="btn btn-danger mt-4 animate-up-2" style="float:right!important;"><i class="fas fa-spinner"></i> {{propsdata[0]['translation']['cancel-reasons-details-continue-loading-button']}}</button>
                </div>
              </div>
              <div v-if="are_you_sure && !canceled">
                  <h5 class="mb-2">{{propsdata[0]['translation']['cancel-reasons-accept-title']}}</h5>
                  <p>{{propsdata[0]['translation']['cancel-reasons-accept-description']}}</p>
                  <div class="d-flex justify-content-between" style="gap: 5px;">
                    <a href="/dashboard/billing" class="btn btn-secondary mt-4 animate-up-2"><i class="fas fa-chevron-left"></i> {{propsdata[0]['translation']['cancel-reasons-return-to-billing']}}</a>
                    <button v-if="!cancelling" @click="cancel" class="btn btn-danger mt-4 animate-up-2" style="float:right!important;">{{propsdata[0]['translation']['cancel-reasons-accept-cancel-button']}}</button>
                    <button v-if="cancelling" class="btn btn-danger mt-4 animate-up-2" style="float:right!important;"><i class="fas fa-spinner"></i> {{propsdata[0]['translation']['cancel-reasons-accept-cancelling-button']}}</button>
                  </div>
                  <p v-if="cancellation_error" class="mt-3" style="color:red;">{{propsdata[0]['translation']['cancel-reasons-accept-error-1']}} <a href="https://qr.io/contact" target="_blank" style="color: red; text-decoration: underline;">{{propsdata[0]['translation']['cancel-reasons-accept-error-2']}}</a>.</p>
              </div>
              <div v-if="canceled">
                <h5 class="mb-2">{{propsdata[0]['translation']['cancel-reasons-canceled-title']}}</h5>
                <p>{{propsdata[0]['translation']['cancel-reasons-canceled-description']}}</p>
                <h5 class="mb-2">{{propsdata[0]['translation']['cancel-reasons-restart-title']}}</h5>
                <p>{{propsdata[0]['translation']['cancel-reasons-restart-description-1']}} <a :href="'https://qr.io/reactivate-account.php?unique_id='+propsdata[0].unique_id" style="color:#00d56d;text-decoration:underline;">{{propsdata[0]['translation']['cancel-reasons-restart-description-2']}}</a></p>
                <a href="/dashboard/billing" class="btn btn-secondary mt-4 animate-up-2"><i class="fas fa-chevron-left"></i> {{propsdata[0]['translation']['cancel-reasons-return-to-billing']}}</a>
              </div>
            </div>
            <div v-else>
              <div class="col-12 p-0">
                <h4 class="mb-0">{{propsdata[0]['translation']['cancel-reasons-not-subscribed']}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
    .activetabs{
    background: #ffffff!important;
    border-color: #dde1ed!important;
    color: #11ab7c!important;
    }
</style>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        reason: '',
        other_reason: '',
        saving: false,
        select_reason: false,
        fill_reason: false,
        are_you_sure: false,
        cancelling: false,
        canceled: false,
        cancellation_error: false
      };
    },
    methods: {
      save_reason(){
        if(this.reason == ''){
          this.select_reason = true;
        }
        else{
          if(this.reason == '4' && this.other_reason == ''){
            this.fill_reason = true;
          }
          else{
            this.select_reason = false;
            this.fill_reason = false;
            this.saving = true;
            axios.post('/dashboard/save-reason.php', {
              token: lukastoken,
              reason: this.reason,
              other_reason: this.other_reason
            })
            .then(response => {
              this.are_you_sure = true;
            })
            .catch(function (error) {
              console.log(error);
            });
          }
        }
      },
      cancel(){
        if(this.cancelling){ // If cancellation is already in progress, terminate method
          return;
        }
        this.cancellation_error = false;
        this.cancelling = true;
        axios.post('https://qr.io/user-cancel-subscription', {
          token: lukastoken
        })
        .then(response => {
          if(response.data == 'Subscription cancellation scheduled successfully.'){
            this.canceled = true;
          }
          else{
            this.cancellation_error = true;
          }
          this.cancelling = false;
        })
        .catch((error) => {
          console.log(error);
          this.cancelling = false;
          this.cancellation_error = true;
        });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/cancel-reasons.vue